import { combine, createEffect, createStore } from "effector"

import AssetCategories from "models/AssetCategories"
import AssetService from "services/AssetService"

export const $assetCategories = createStore<AssetCategories | null>(null)

export const fetchAssetCategories = createEffect(async ({ ignoreCache }: { ignoreCache?: boolean } = {}) => {
    if (!ignoreCache) {
        const cache = $assetCategories.getState()
        if (cache) return cache
    }
    return AssetService.getAssetCategories()
})

export const $isFetchingAssetCategories = combine([
    fetchAssetCategories.inFlight,
], ([count]) => count > 0)

$assetCategories.on(fetchAssetCategories.doneData, (_, payload) => payload)
